import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { invitationsService } from '../api/members.service';
import { INVITATIONS_KEYS } from './queryKeys';
import { DEFAULT_PAGE_SIZE } from '@/shared/types/pagination';
import type { InvitationDto } from '../types';

export interface UseAdminInvitationsResult {
  invitations: InvitationDto[];
  totalCount: number;
  isLoading: boolean;
  isError: boolean;
  isFetching: boolean;
}

export function useAdminInvitations(
  search = '',
  pageIndex = 0,
  pageSize = DEFAULT_PAGE_SIZE,
): UseAdminInvitationsResult {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  const params = {
    SearchTerm: search || undefined,
    Page: pageIndex + 1,
    PageSize: pageSize,
  };

  const { data, isLoading, isError, isFetching } = useQuery({
    queryKey: INVITATIONS_KEYS.list(orgId ?? '', params),
    queryFn: ({ signal }) => invitationsService.getAll(params, signal),
    staleTime: 60_000,
    enabled: !!orgId,
    placeholderData: keepPreviousData,
  });

  return {
    invitations: data?.items ?? [],
    totalCount: data?.totalCount ?? 0,
    isLoading,
    isError,
    isFetching,
  };
}
